import React from 'react'
import StyledDiv from '../styles'
import theme from '../../../theme'

interface IProps {
  tag: string
  color: string
  clickable: boolean
}

export const TagComponent: React.FC<IProps> = ({
  tag,
  color,
  clickable
}) => {

  const fontColor = () => {
    if (color === theme.colors.blue) return theme.colors.white
    else return theme.colors.black
  }

  const getBackgroundColor = () => {
    if (color == "#FFFFFFFF") return `${"#000000"}20`
    else return `${color}80`
  }

  const getCursorType = () => {
    return clickable ? 'pointer' : 'default'
  }

  return (
    <StyledDiv className='tag-container' style={{ backgroundColor: getBackgroundColor(), cursor: getCursorType() }} >
      <span className='tag-text' style={{ color: fontColor(), cursor: getCursorType() }}>
        { tag }
      </span>
    </StyledDiv>
  )
}